import React from 'react'

export default function Line() {
  return (
    <div style={{backgroundColor: "#DDDDDD", width: "100%", height: "1px" }}></div>
  )
}
